// extracted by mini-css-extract-plugin
export default {"schedulePage":"SchedulePage_schedulePage__+TgVn"};